import { Xmark } from '@peacecover/icon';
import type { components } from '@pocapan/shared/types/schema';

type CastRelationship = components['schemas']['ApiV1CastRelationship'];

interface CastRelationshipBadgeProps {
  castRelationship?: CastRelationship;
  className?: string;
}

export const CastRelationshipBadge = ({
  castRelationship,
  className
}: CastRelationshipBadgeProps) => {
  if (!castRelationship) return null;
  const { personA, personB } = castRelationship ?? {};

  return (
    <div
      className={`flex items-center gap-[5px] px-[6px] py-[4px] bg-surface-lv2 rounded-[4px] text-text-main-lv4 w-fit ${className ?? ''}`}
    >
      <p className="text-[12px] font-medium leading-[14px]">{personA?.name}</p>
      <Xmark size={12} />
      <p className="text-[12px] font-medium leading-[14px]">{personB?.name}</p>
    </div>
  );
};
